import { FC, useEffect } from 'react';
import {
  StoryList,
  ContentLoader,
  SeoBlock,
  useAdvertListData,
  PageTitle,
  Page,
} from '@edikk-edikk/ui';
import { setApiError } from '@edikk-edikk/redux/slice-base';
import { ApiError } from '@edikk-edikk/network-service';
import { CatalogByDate, CatalogByService } from '#advertList/components';
import { useInit } from '#advertList/hooks';
import { Filter } from '#advertList/components/filter/Filter';
import { AdvertListContext } from '#advertList/contexts/AdvertListContext';
import { AdvertListContextType } from '#advertList/contexts/AdvertListContextType';
import { AdvertListMetaData } from '#advertList/components/AdvertListMetaData';
import { useAppDispatch } from '#components/redux/hooks';

type PropsType = {
  categoryId?: number;
  cityId?: number;
  areaId?: number;
};

const List: FC<PropsType> = ({
  categoryId = undefined,
  cityId = undefined,
  areaId = undefined,
}) => {
  const init = useInit(categoryId, cityId, areaId);
  const {
    data,
    advertDataListByDate,
    advertDataListByService,
    isFetching,
    isError,
    error,
  } = init();
  const advertListData = useAdvertListData();
  const dispatch = useAppDispatch();

  if (ApiError.check(error)) {
    dispatch(setApiError(error));
  }

  useEffect(() => {
    advertListData.setCategoryId(categoryId).setCityId(cityId).setAreaId(areaId);

    return () => {
      advertListData.truncate();
    };
  }, [categoryId, cityId, areaId, advertListData]);

  if (isFetching) {
    return <ContentLoader />;
  }

  if (isError) {
    return null;
  }

  const advertListContextValue: AdvertListContextType = {
    storyDataList: data.storyDataList,
    filterData: data.filterData,
    advertDataListByDate,
    advertDataListByService,
    seo: data.seo,
    categoryId,
    cityId,
    areaId,
  };

  return (
    <AdvertListContext.Provider value={advertListContextValue}>
      <AdvertListMetaData />
      <Page>
        <StoryList storyDataList={data.storyDataList} />
        <PageTitle title={data.seo.h1} />
        <Filter />
        <CatalogByDate />
        <CatalogByService />
        <SeoBlock text={data.seo.text} categoryList={data.seo.categoryList} cityList={data.seo.cityList} />
      </Page>
    </AdvertListContext.Provider>
  );
};

export default List;
